<style scoped lang="scss">
.box {
  width: 100%;
  box-sizing: border-box;
  background: #f2f2f2;
  padding: 0 20px 20px 280px;

  .page_title {
    height: 50px;
    line-height: 50px;
    background: #ffffff;
    border-left: 10px solid #3399ff;
    font-size: 16px;
    font-family: "微软雅黑 Bold", "微软雅黑 Regular", "微软雅黑";
    color: #666666;
    font-weight: 700;
    padding-left: 15px;
  }

  .elmargin {
    margin-bottom: 21px;
  }
}

.tree_box {
  width: 100%;
  padding: 20px;
  background: #fff;
  box-sizing: border-box;

  p {
    padding: 0;
    margin: 0;
    color: #666;
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 20px;
  }
}

.el-table {
  width: 99.9% !important;
}
</style>
<template>
  <div
      class="box"
      element-loading-text="正在查询,请稍候..."
  >
    <p class="page_title">用户管理</p>
    <el-row :gutter="20" style="width: 100%;padding: 0;margin: 0;">
      <el-col :span="5" style="padding-left:0">
        <department-tree @onNodeClick="onDepartmentNodeClick"></department-tree>
      </el-col>
      <el-col
          :span="19"
          style="background: #fff; padding: 50px 15px; padding-top: 5px; box-sizing: border-box"
      >
        <div class="query_box">
          <el-form
              :model="form"
              ref="form"
              label-position="100px"
              size="medium"
          >
            <h2 style="margin-bottom: 20px">{{this.currentDepartmentName == null ? '组织架构' : this.currentDepartmentName}}</h2>
            <el-row :gutter="10">
              <el-col :span="4" class="elmargin">
                <el-input
                    v-model="form.userName"
                    size="medium"
                    placeholder="请输入姓名或者用户名"></el-input>
              </el-col>
<!--              <el-col :span="4" class="elmargin">-->
<!--                <el-input-->
<!--                    v-model="form.name"-->
<!--                    size="medium"-->
<!--                    placeholder="请输入用户名"></el-input>-->
<!--              </el-col>-->
              <el-col :span="6">
              <el-form-item label="角色" >
                <el-select v-model="form.roleId" clearable filterable placeholder="请选择角色" size="medium">
                  <el-option
                      v-for="item in roles"
                      :key="item.name"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-button size="medium" type="primary" icon="el-icon-search" @click="qryInfo()">查询</el-button>
                <el-button size="medium" icon="el-icon-refresh" @click="reset()">重置</el-button>
              </el-col>
              <el-col :span="4">
                <el-button size="medium" type="primary" icon="el-icon-plus" @click="addVisible = true">新增用户</el-button>
                <el-button size="medium" type="primary" @click="exportExcel">导出</el-button>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="table_box">
          <data-table
              :columns="tableColumns"
              :data="tableData1"
              @selects="selects"
          >
            <el-table-column fixed="right" label="操作" min-width="100">
              <template slot-scope="scope">
                <el-button
                    @click="handleClick(scope.$index, scope.row)"
                    type="primary"
                    icon="el-icon-edit"
                >编辑
                </el-button>
                <el-button type="danger" icon="el-icon-delete" @click="removeUser(scope.$index, scope.row)">删除
                </el-button>
                <el-button type="primary" icon="el-icon-edit" @click="resetPwd(scope.$index, scope.row)">重置密码
                </el-button>
              </template>
            </el-table-column>
          </data-table>
          <Pagination :page.sync="page" @pageChange="qryInfo()"/>
          <the-add
              :visible.sync="addVisible"
              :form="addForm"
              @success="operationaddSuccess"
          ></the-add>
          <edit
              :editForm="selectedData"
              :visible.sync="editVisible"
              @success="operationSuccess"
          ></edit>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import index from "@/components/mixins/index";
import DataTable from "@/components/common/DataTable.vue";
import TheAdd from "./TheAdd";
import Edit from "./Edit";
import {getFuncTree, getUser, deleteUser, resetPwd, selectRole} from "./api/index"
import DepartmentTree from "./component/departmentTree";
import request from '@/utils/apiRequest'
import {selectParentOrg} from "../../businessManage/personManage/personInfo/api";

export default {
  mixins: [index],
  data() {
    return {
      form: {
        name: "",
      },
      data: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      tableColumns: [
        {label: "用户名", prop: "account", minWidth: "30", sort: true},
        {label: "姓名", prop: "name", minWidth: "30"},
        {label: "电话", prop: "mobile", minWidth: "40"},
        {label: "所属组织", prop: "orgName", minWidth: ""},
        {label: "邮箱", prop: "email", minWidth: "50"},
        {label: "最后修改人", prop: "lastUpdUser", minWidth: "30"},
        {label: "最后修改时间", prop: "lastUpdTime", minWidth: "60"},
      ],
      tableData1: [],
      roles: [],
      addVisible: false,
      editVisible: false,
      selectedData: {},
      currentDepartmentName: null,
      currentDepartmentId: null,
      addForm: {
        account: "",
        name: "",
        remark: "",
        mobile: "",
        email: "",
        roleIds: [],
        groupIds: [],
        departmentId: null,
        departmentName: ''
      }
    };
  },
  methods: {
    //获取角色列表
    selectRole(){
      selectRole()
          .then((res) =>{
            this.roles = res.data.data
          })
    },
    // 导出用户
    exportExcel() {
      let data = {};
      data.account = this.form.name;
      data.name = this.form.userName;
      data.roleId = this.form.roleId;
      data.orgId = this.currentDepartmentId == null ? '' : this.currentDepartmentId
      request({
        url: "/user/SysUserWsg/excelExport",
        method: "get",
        params: data,
        loading: true,
        responseType: 'blob'
      }).then(res => {
        this.$message.success('操作成功')
      })
    },
    // 组织架构节点点击后的回调
    onDepartmentNodeClick(node) {
      this.currentDepartmentName = node.name
      this.currentDepartmentId = node.id
      this.qryInfo(node.id)
      this.addForm.departmentId = node.id
      this.addForm.departmentName = node.name
    },
    // 重置查询
    reset() {
      this.form.name = ""
      this.form.userName = ""
      this.form.roleId = ""
      this.currentDepartmentName = null
      this.currentDepartmentId = null
      this.qryInfo(null)
    },
    resetPwd(index, row) {
      this.$confirm('确定要重置密码吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        resetPwd(row.id).then(res=>{
          this.$message({
            type: 'success',
            message: '重置成功!'
          });
        }).catch(()=>{
          this.$message({
            type: 'info',
            message: '重置失败!'
          });
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消重置'
        });
      });
    },
    getTree() {
      getFuncTree()
          .then((res) => {
            this.data = res.data.data;
          })
          .catch((err) => {
            this.loading = false;
            this.$alert("服务器发生错误，请联系系统管理员", "登录失败", {
              type: "error",
            })
          });
    },
    qryInfo(orgId) {
      // orgId = this.currentDepartmentId == null ? '' : this.currentDepartmentId
      // orgId = this.currentDepartmentId
      if(orgId==null||orgId===''){
        // this.currentDepartmentName = null
        // this.currentDepartmentId = null
        orgId = this.currentDepartmentId
      }

      let data = {};
      data.account = this.form.name;
      data.name = this.form.userName;
      data.roleId = this.form.roleId;
      data.current = this.page.pageNum;
      data.size = this.page.pageSize;
      data.orgId = orgId == null ? '' : orgId
      getUser(data)
          .then((res) => {
            this.tableData1 = res.data.data.records;
            this.page.total = res.data.data.total;
          })
          .catch((err) => {
            this.loading = false;
            this.$alert("服务器发生错误，请联系系统管理员", "登录失败", {
              type: "error",
            })
          });
    },
    operationaddSuccess() {
      this.addVisible = false;
      this.qryInfo(this.currentDepartmentId);
    },
    operationSuccess() {
      this.editVisible = false;
      this.qryInfo(this.currentDepartmentId);
    },
    handleClick(index, row) {
      this.selectedData = Object.assign({}, row);
      this.editVisible = true;
    },
    removeUser(index, row) {
      this.$confirm(
          "此操作将永久删除该用户, 是否继续?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
      )
          .then(() => {
            let id = row.id;
            deleteUser(id)
                .then((res) => {
                  this.$message({
                    type: "info",
                    message: "删除成功",
                  });
                  this.qryInfo();
                })
                .catch((err) => {
                  this.loading = false;
                  this.$alert("服务器发生错误，请联系系统管理员", "登录失败", {
                    type: "error",
                  });
                });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
    },
  },
  components: {
    DepartmentTree,
    DataTable,
    TheAdd,
    Edit,
  },
  mounted() {
    this.getTree();
    this.qryInfo();
    this.selectRole();
  }
};
</script>

